import produce from 'immer'
import { Reducer } from 'redux'

import {
  SET_USER_URN
} from 'redux/actions/types'

interface UsersState {
  userUrn: string | null
}

const initialState: UsersState = {
  userUrn: null
}

const users: Reducer<UsersState, any> = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_URN:
      return produce(state, draft => {
        draft.userUrn = action.userUrn
      })
    default:
      return state
  }
}

export default users
